import React from "react"
import {
  Text, Flex, Radio, Stack,
  RadioGroup,
} from "@chakra-ui/react"
import { Control, useController } from "react-hook-form"
import { asMoney } from "utilities/strings"

type Props = {
  options: {
    label: string
    amount: string
  }[]
  control: Control
  name: string
  onChange: (value: string) => void
}

const RadioBoxes = ({
  options, control, name, onChange,
}: Props) => {
  const { field } = useController({ name, control })

  return (
    <RadioGroup
      w="100%"
      value={field.value}
      onChange={(value) => {
        onChange(value)
        field.onChange(value)
      }}
    >
      <Stack spacing={3} my={7}>
        {options.map(({ label, amount }) => (
          <Flex
            alignItems="center"
            justifyContent="space-between"
            borderWidth={1}
            h={14}
            borderRadius="md"
            px={4}
            borderColor={field.value === amount ? "blue.400" : undefined}
            backgroundColor={field.value === amount ? "blue.50" : "gray.100"}
            onClick={() => {
              onChange(amount)
              field.onChange(amount)
            }}
            cursor="pointer"
          >
            <Radio value={amount}>
              <Text fontWeight="semibold">{label}</Text>
            </Radio>
            <Text>{asMoney(amount, "USD")}</Text>
          </Flex>
        ))}
      </Stack>
    </RadioGroup>
  )
}

export default RadioBoxes
